export default "__VITE_ASSET__8$pLhO4$__"